"use client";

import { MarketingNotFoundAnalytics } from "@marketing/shared/components/marketing-not-found-analytics";
import { Button } from "@repo/ui/components/button";
import { GlassPanel } from "@shared/components/GlassPanel";
import { InteractiveHexagonBackground } from "@shared/components/InteractiveHexagonBackground";
import { ArrowLeftIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { LocaleLink } from "@/modules/i18n/routing";

/** Marketing 404: same interactive hex backdrop as waitlist public pages, centered lime glass panel. */
export function MarketingNotFoundContent() {
	const t = useTranslations();
	const tHero = useTranslations("marketing.landing.hero");

	return (
		<div className="relative isolate flex w-full flex-1 flex-col overflow-hidden min-h-[calc(100dvh-var(--marketing-site-header-height,7rem))]">
			<MarketingNotFoundAnalytics />
			<InteractiveHexagonBackground
				interactiveAriaLabel={tHero("interactiveBackgroundAria")}
				className="min-h-0 w-full flex-1"
				contentWrapperClassName="items-center justify-center px-4"
			>
				<GlassPanel tone="light">
					<h1 className="font-bold text-5xl">{t("notFound.code")}</h1>
					<p className="mt-2 text-2xl">{t("notFound.title")}</p>

					<Button asChild className="mt-4">
						<LocaleLink href="/">
							<ArrowLeftIcon className="mr-2 size-4" />{" "}
							{t("notFound.goToHomepage")}
						</LocaleLink>
					</Button>
				</GlassPanel>
			</InteractiveHexagonBackground>
		</div>
	);
}
